import "../../styles/layout.scss";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { IconButton } from "@mui/material";

export const Footer = () => {
    return (
        <div className="layout__footer">
            <IconButton>
                <NotificationsNoneIcon fontSize="medium" className="layout__footer__icon" style={{margin: 0}} />
            </IconButton>
            <IconButton>
                <ChatBubbleOutlineIcon fontSize="medium" className="layout__footer__icon" style={{margin: 0}}  />
            </IconButton>

        </div>
    )
}